import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { I18NextModule } from 'angular-i18next';
import { HbSharedModule } from 'app/shared/hb-shared.module';
import { HbSharedUiModule } from 'app/shared/ui/hb-shared-ui.module';
import { MessagesModule } from 'primeng/messages';
import { AuthInputComponent } from './auth-input/auth-input.component';
import { AuthenticationRoutingModule, routedComponents } from './authentication-routing.module';
import { CatalogerrorComponent } from './catalogerror/catalogerror.component';
import { LoginContainerComponent } from './login-container/login-container.component';
import { PasswordResetDialogComponent } from './password-reset/password-reset-dialog.component';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { ReportingRoleNotificationComponent } from './reporting-role-notification/reporting-role-notification.component';
import { SessionTimeoutComponent } from './session-timeout/session-timeout.component';

@NgModule({
  imports: [AuthenticationRoutingModule, CommonModule, MessagesModule, FormsModule, ReactiveFormsModule, HbSharedUiModule, HbSharedModule, I18NextModule.forRoot(),],
  declarations: [
    routedComponents,
    AuthInputComponent,
    PasswordResetComponent,
    PasswordResetDialogComponent,
    SessionTimeoutComponent,
    LoginContainerComponent,
    ReportingRoleNotificationComponent,
    CatalogerrorComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [PasswordResetDialogComponent, PasswordResetComponent],
  exports: [PasswordResetComponent, SessionTimeoutComponent],
  providers: [],
})
export class AuthenticationModule { }
